<script lang="ts" setup>
import { ref, computed, watch } from "vue";
import { Chart as ChartJS, Tooltip, Legend, RadialLinearScale, PointElement, LineElement, Filler } from "chart.js";

import { Radar } from "vue-chartjs";

const props = defineProps({
  sourceData: {
    type: Array,
    required: true,
    default: function () {
      return [];
    },
  },
  chartStyle: {},
});

const chartData = ref({
  labels: ["Strategie", "Inzicht", "Gedeelde waarden", "Status", "Slagkracht"],

  datasets: [
    {
      label: "score",
      fill: true,
      backgroundColor: "rgba(179,181,198,0.2)",
      borderColor: "rgba(179,181,198,1)",
      pointBackgroundColor: "rgba(179,181,198,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(179,181,198,1)",
      data: null,
    },
  ],
});

const chartOptions = computed(() => {
  return {
    responsive: false,
    maintainAspectRatio: true,
    scales: {
      r: {
        min: 0,
        max: 7,
        beginAtZero: true,
        // grid: {
        //   color: ["black", "#CCCCCC", "#EFD0D0", "#F9D1D1", "#FADECD", "#EEF2D3", "#E6EACC", "#DCDFCC"],
        // },
      },
    },
    ticks: {
      stepSize: 1, // the number of step
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };
});

watch(
  () => props.sourceData,
  () => {
    chartData.value.datasets[0].data = [...props.sourceData];
    chartData.value = {
      ...chartData.value,
      datasets: [...chartData.value.datasets],
    };
  },
  { deep: true, immediate: true }
);

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);
</script>
<template>
  <div>
    <Radar :data="chartData" :options="chartOptions" :style="props.chartStyle" />
  </div>
</template>
